export default class SettingNotFoundException extends Error {
  static exceptionName = 'SettingNotFoundException'

  constructor(message) {
    super(message)
    this.name = SettingNotFoundException.exceptionName
  }
}
